import React, { useEffect, useRef, useState } from 'react'
import MDButton from 'components/MDButton';
import MDBox from 'components/MDBox';
import { Backdrop, CircularProgress, Modal } from '@mui/material';
import { addAboutImage, getAbout, updateAbout } from './../../api/routes';
import { Editor } from 'react-draft-wysiwyg';
import editorToolbar from './../../components/editorToolbar';
import draftToHtml from 'draftjs-to-html';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import parse from 'html-react-parser';
import urltoFile from './../../components/urlToFile';
import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    height: 'fit-content',
};

export default function About() {
    const [data, setData] = useState();
    const [editorState, setEditorState] = useState();
    const [isImageUpload, setIsImageUpload] = useState(false);
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => setOpen(true);
    const [loading, setLoading] = useState(false);
    const handleOpenLoading = () => {
        setLoading(true);
    };
    const handleCloseLoading = () => {
        setLoading(false);
    };
    const editInfo = () => {
        if (data[0].aboutText) {
            const blocksFromHtml = htmlToDraft(data[0].aboutText);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const editorState = EditorState.createWithContent(contentState);
            setEditorState(editorState)
            handleOpen()
        } else return handleOpen()
    }
    useEffect(() => {
        handleOpenLoading()
        handleClose()
        getAbout((isOk, data) => {
            if (!isOk) {
                handleCloseLoading()
                return toast.error(data.message);
            }
            else {
                handleCloseLoading()
                return setData(data)
            }
        })
    }, [])

    const updateAboutInfo = () => {
        const data = {
            aboutText: draftToHtml(convertToRaw(editorState.getCurrentContent())),
        }
        handleOpenLoading()
        handleClose()
        updateAbout(data, (isOk, data) => {
            if (!isOk) return toast.error(data.message)

            else {
                if (sessionStorage.getItem('aboutimage') !== null) {
                    urltoFile(sessionStorage.getItem('aboutimage'), 'file.jpeg', 'image/jpeg')
                        .then(function (file) {
                            imageCompression(file)
                                .then(function (compressedFile) {
                                    const formData = new FormData();
                                    formData.append("aboutImage", new File([compressedFile], "file.jpeg", { type: "text/json;charset=utf-8" }));
                                    addAboutImage(formData, (isOk, data) => {
                                        if (!isOk) {
                                            handleCloseLoading()
                                            return toast.error(data.message);
                                        }
                                        else {
                                            sessionStorage.removeItem('aboutimage');
                                            return window.location.reload();
                                        }
                                    })
                                })
                                .catch(function (error) {
                                    console.log(error.message);
                                });

                        })
                } else return window.location.reload();
            }
        })
    }

    const file = useRef(null);

    const uploadImage = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            if (event.target.files[0].size / 1024 / 1024 < 6) {
                const reader = new FileReader();
                reader.readAsDataURL(event.target.files[0]);
                reader.onload = (event) => {
                    sessionStorage.setItem("aboutimage", event.target.result);
                    setIsImageUpload(true)
                };
            } else toast.error("حجم فایل باید کمتر از 6 مگابایت باشد");
        }
    }


    return (
        <div style={{ padding: '1rem' }}>
            <p style={{ fontWeight: 'bold' }}>درباره مرکز : </p>
            <p style={{ marginTop: '1rem' }}>{data && data[0].aboutText && parse(data[0].aboutText)}</p>
            <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>تصویر درباره مرکز : </p>
            <p>{data && data[0].image && <img src={`data:image/jpeg;base64,${data[0].image}`} alt='doctor' style={{ width: '200px', height: '200px', objectFit: 'contain' }} />}</p>

            <MDButton onClick={editInfo} variant="gradient" color="info" sx={{ width: '120px', marginTop: '2rem' }}>
                ویرایش
            </MDButton>
            <Modal open={open} onClose={handleClose}>
                <MDBox sx={style}>
                    <input ref={file} type="file" accept="image/*" style={{ display: 'none' }} onChange={uploadImage} />
                    <div style={{ borderRadius: '8px', display: 'flex', marginTop: '1rem', padding: '0 1rem', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #d2d6da', height: '56px' }} onClick={() => file?.current?.click()}>
                        <p style={{ color: '#00000099', fontSize: '1rem' }}>تصویر درباره مرکز</p>
                        {isImageUpload ? <p style={{ color: 'rgb(74 222 128)', fontSize: '1rem' }}>آپلود شد</p> : <p style={{ color: '#00000099', fontSize: '1rem' }}>آپلود کنید</p>}
                    </div>

                    <MDBox style={{ direction: 'ltr', marginTop: '1rem' }}>
                        <Editor
                            editorState={editorState}
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="body-editor"
                            placeholder='درباره مرکز'
                            onEditorStateChange={(editorState) => setEditorState(editorState)}
                            toolbar={editorToolbar()}
                        />
                        <MDButton onClick={updateAboutInfo} variant="gradient" color="info" sx={{ width: '120px', marginTop: '2rem' }}>
                            تایید
                        </MDButton>
                    </MDBox>
                </MDBox>
            </Modal>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}
